import React, { Component } from "react";
import { connect } from "react-redux";
//import { fetchDashboards } from "Thunks";

import DashboardComponent from "./DashboardComponent";

class DashboardContainer extends Component {
  /*componentDidMount() {
    const { fetchDashboards } = this.props;
    fetchDashboards({ limit: 10 });
  }*/

  render() {
    const { user, community } = this.props;
    if (!user || !user.role || !user.role.organization) {
      return null;
    }

    return (
      <DashboardComponent community={/*community*/ user.role.organization} />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  //fetchDashboards: type => dispatch(fetchDashboards(type))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardContainer);



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Dashboard/DashboardContainer.js